import {EventEmitter} from "@angular/core";

export class HeaderTagBase {
    id: number;
    name: string;
    label: string;
    desc: string;

    notifyParent: EventEmitter<any> = new EventEmitter();

    public Clear() {
        this.id = 0;
        this.name = '';
        this.label = '';
        this.desc = '';
    }

    public load(adata){
        this.id = adata.id;
        this.name = adata.name;
        this.label = adata.label;
        this.desc = adata.description;
        this.notifyParent.emit();
    }    
}
